<div class="card full-card shadow-sm m-4 card-v-center">
  <div class="card-body">
    <div class="row col-12">
      <div class="col-md-3 mt-3 align-center">
        <img class="img" src="/assets/images/rda/Richiesta_assistenza.svg" alt="imgHelpDesk" width="150" height="150">
      </div>
      <div class="col-md-9 align-center center">
        <h2><b translate>rda.new-rda</b></h2>
        <h4 class="extra-small-margin" translate>
          rda.fill-data
        </h4>
      </div>
    </div>
    <hr>
      <div class="container">
        <div class="row">
          <div class="col-md-6 justify-content-between p-1">
            <app-label class="helpLabel" text="rda.fullname" tooltip="tooltip.helpDesk.nameAndSurname">
            </app-label>
            <input type="text" class="w-100 form-control form-input input-with-border"
              [(ngModel)]="helpDeskForm.nameAndSurname" [disabled]="true">
            @if (this.helpDeskForm.nameAndSurname == null) {
              <div class="invalid-feedback" translate>
                generic.message.validation.mandatory-error
              </div>
            }
          </div>
          <div class="col-md-6 justify-content-between p-1">
            <app-label class="helpLabel" text="rda.email" tooltip="tooltip.helpDesk.email">
            </app-label>
            <input type="email" id="email" name="email" class="w-100 form-control form-input input-with-border"
              [(ngModel)]="helpDeskForm.email" [disabled]="true">

            @if (StringUtils.isEmpty(this.helpDeskForm.email)) {
              <div class="invalid-feedback" translate>
                generic.message.validation.mandatory-error
              </div>
            }
          </div>
        </div>

        <div class="row pt-4">
          <div class="col-md-6 justify-content-between p-1">
            <app-label class="helpLabel" text="rda.email.cc" tooltip="tooltip.helpDesk.ccEmail">
            </app-label>
            <input type="email" class="w-100 form-control form-input input-with-border"
              [(ngModel)]="helpDeskForm.ccEmail">
            @if (invalidCCEmail) {
              <div class="invalid-feedback" translate>
                generic.message.validation.invalid-email
              </div>
            }
          </div>
          <div class="col-md-6 justify-content-between p-1">
            <app-label class="helpLabel" text="rda.phone" tooltip="tooltip.helpDesk.phone">
            </app-label>
            <input id="phone" type="text" name="phone" class="w-100 form-control form-input input-with-border"
              mask="9999999999" [(ngModel)]="helpDeskForm.phone" (keypress)="phoneAllowedInput($event)"
              (input)="phoneValidator($event)">
            @if (phoneErrors) {
              <div class="invalid-feedback" translate>
                generic.message.validation.mandatory-error
              </div>
            }
          </div>
        </div>

        <div class="row pt-4">
          <div class="col-md-6 justify-content-between p-1">
            <app-label class="helpLabel" text="rda.request-type" tooltip="tooltip.helpDesk.requestType">
            </app-label>
            <ng-select
              id="requestType"
              name="requestType"
              bindValue="key" bindLabel="label"
              [(ngModel)]="helpDeskForm.requestType"
              [disabled]="selectedPlanEnabled"
              (change)="helpDeskForm.categoryRequest = helpDeskForm.requestType && helpDeskForm.requestType === RequestTypeEnum.PLATFORM_REQUEST ? helpDeskForm.categoryRequest : null"
              >
              @for (option of requestTypes; track option) {
                <ng-option [value]="option.key">
                  {{("help-desk.request-type." + option.key) | translate}}
                </ng-option>
              }
            </ng-select>

            @if (this.helpDeskForm.requestType == null) {
              <div class="invalid-feedback" translate>
                generic.message.validation.mandatory-error
              </div>
            }
          </div>
          @if (helpDeskForm.requestType && helpDeskForm.requestType.toString() === 'PLATFORM_REQUEST') {
            <div class="col-md-6 justify-content-between p-1"
              >
              <app-label class="helpLabel" text="rda.category" tooltip="tooltip.helpDesk.categoryRequest">
              </app-label>
              <ng-select
                id="categoryRequests"
                name="categoryRequests"
                bindValue="key"
                bindLabel="label"
                [disabled]="selectedPlanEnabled"
                [(ngModel)]="helpDeskForm.categoryRequest">
                @for (option of categoryRequests; track option) {
                  <ng-option [value]="option.key">
                    {{ ("help-desk.category-request." + option.key) | translate}}
                  </ng-option>
                }
              </ng-select>
              @if (this.helpDeskForm.categoryRequest == null) {
                <div class="invalid-feedback" translate>
                  generic.message.validation.mandatory-error
                </div>
              }
            </div>
          }
        </div>

        @if (!selectedPlanEnabled) {
          <div class="row pt-4">
            <div class="col-md-6 justify-content-between p-1">
              <app-label class="helpLabel" text="rda.object" tooltip="tooltip.helpDesk.objectRequest">
              </app-label>
              <input type="text" class="w-100 form-control form-input input-with-border"
                [(ngModel)]="helpDeskForm.objectRequest">
              @if (StringUtils.isEmpty(this.helpDeskForm.objectRequest)) {
                <div class="invalid-feedback" translate>
                  generic.message.validation.mandatory-error
                </div>
              }
              @if (this.helpDeskForm.objectRequest!== null && this.helpDeskForm.objectRequest.length > 40) {
                <div class="invalid-feedback"
                  translate>
                  generic.message.validation.not-valid-field
                </div>
              }
            </div>
          </div>
        }

        @if (!selectedPlanEnabled) {
          <div class="row pt-4">
            <div class="col-md-12 justify-content-between p-1">
              <app-label class="helpLabel" text="rda.message" tooltip="tooltip.helpDesk.message">
              </app-label>
              <textarea class="form-control input-with-border" style="width:100%"
              [(ngModel)]="helpDeskForm.message"></textarea>
              @if (StringUtils.isEmpty(this.helpDeskForm.message)) {
                <div class="invalid-feedback" translate>
                  generic.message.validation.mandatory-error
                </div>
              }
            </div>
          </div>
        }

        @if (!selectedPlanEnabled) {
          <div class="row pt-4">
            <div class="col-md-12 justify-content-between p-1">
              <app-label class="helpLabel" text="generic.attachment" [(ngModel)]="helpDeskForm.attachment"
                tooltip="tooltip.helpDesk.attachment">
              </app-label>
            </div>
            <div class="mt-2 col-12 p-1">
              <input type="file" (change)="handleUpload($event)">
            </div>
          </div>
        }

      </div>
      <hr>

        <div class="d-flex justify-content-between align-items-center">
          <button class="me-auto btn btn-back d-flex align-items-center" (click)="goBack()">
            <span class="ms-3" style="align-self: center; font-size: 0.8rem; font-weight: 500"><b>←
              <span translate>actions.back</span></b></span>
            </button>
            <button class="not btn btn-primary btn-rounded" (click)="goBack()" translate>
              actions.cancel
            </button>
            <button class="btn btn-primary btn-rounded" (click)="sendRequest()" [disabled]="!isFormValid() || !isUploadReady"
              translate>
              actions.send
            </button>
          </div>

        </div>
      </div>

      <pwc-modal #confirmTechRequest [id]="'confirmTechRequest'">
        <span modal-title>{{'help-desk.tech-support-request.title' | translate}}</span>
        <div modal-body>
          <div class="col-12"></div>
          <div [innerHTML]="'help-desk.tech-support-request.message' | translate"></div>
        </div>
        <div modal-footer class="text-end">
          <button type="button" class="btn btn-action btn-success me-2" (click)="confirmTechRequest.close()"
          translate>actions.cancel</button>
          <button type="button" class="btn btn-action btn-primary ms-2" (click)="onConfirm()">Conferma</button>
        </div>
      </pwc-modal>

      <pwc-modal #confirmUpgrade [id]="'confirmUpgrade'" [closable]="false" [dismissable]="false" [escapable]="false"
        [showFooter]="false" class="custom-header">
        <div modal-title></div>
        <div modal-body>
          <div [innerHTML]="'help-desk.tech-support-request-upgrade.message' | translate"></div>
          <div class=" align-self-end">
            <button type="button" class="btn btn-action btn-primary offset-6 col-6" (click)="onClickOkUpgrade()">
              {{'cannot-help-modal.close-button' | translate}}
            </button>
          </div>
        </div>
      </pwc-modal>
